import { docReady } from "../utilities";
import Braze from "../libraries/Braze";

const SUBMIT_KEY = "footer-newsletter-submitted";

docReady(function() {
  // Log the signup on the post-submit return, mirroring InstantPopup.ts. This used to
  // hang off checkFormUrl's `urlchecked === 2` gate, which only came true on the second
  // pass from the load + 500ms timer below, so the event was silently dropped whenever
  // that listener registered after `load` had already fired.
  try {
    if (
      sessionStorage.getItem(SUBMIT_KEY) === "1" &&
      location.href.indexOf('customer_posted=') > -1
    ) {
      Braze.logOnlineSignup({ source: "footer" });
      sessionStorage.removeItem(SUBMIT_KEY);
    }
    // Same lifetime as InstantPopup.ts: clear on every load except the reCAPTCHA challenge.
    if (location.pathname !== '/challenge') sessionStorage.removeItem(SUBMIT_KEY);
  } catch {
    /* sessionStorage unavailable */
  }

  // DOM is loaded and ready for manipulation here
  var menus = document.getElementsByClassName("footer__menu-title");
  var i;

  for (i = 0; i < menus.length; i++) {
    menus[i].addEventListener("click", function event(e) {
      if (window.innerWidth < 992) {
        e.preventDefault();
        this.parentElement.classList.toggle("footer__section--open");
      }
    });
  }
  //Save the id of the submitted form, to set focus back after google recatpcha page is displayed
  const footerNewsletterForm = document.getElementById('customer-newsletter');
  if (footerNewsletterForm) {
    footerNewsletterForm.addEventListener('submit', function(event) {
        if (localStorage) {
            localStorage.setItem('submittedFormID', 'customer-newsletter');
        }
        // Flag the submit; the signup is logged on the post-submit success page.
        try {
            if (footerNewsletterForm.checkValidity()) {
                sessionStorage.setItem(SUBMIT_KEY, "1");
            }
        } catch {
            /* storage blocked */
        }
    })
  }
  let urlchecked = 0;
  function checkFormUrl() {
    urlchecked +=1;
    if (location.href.indexOf('customer_posted=') > -1 || location.href.indexOf('contact%5Btags%5D=newsletter&form_type=customer') > -1) {
        if (localStorage) {            
            const formSubmittedID = localStorage.getItem('submittedFormID');
            if (formSubmittedID) {
                const formSubmitted = document.getElementById(formSubmittedID);
                if (formSubmitted) {
                    window.scrollTo(0, formSubmitted.getBoundingClientRect().top);
                    if (urlchecked >= 2) {
                        localStorage.removeItem('submittedFormID');
                    }
                }
            }
        }
    }
  }
  checkFormUrl();
  window.addEventListener('load', function() {
    setTimeout(function() {checkFormUrl()}, 500);
  });
});
